import { GameScene, InputState, SceneType } from '../types/game.types';
import { RenderManager } from '../core/RenderManager';
import { AudioManager } from '../core/AudioManager';
import { LeaderboardManager } from '../core/LeaderboardManager';
import { LeaderboardDisplay } from './LeaderboardDisplay';

interface LeaderboardSceneCallbacks {
  switchScene: (scene: SceneType) => void;
}

export class LeaderboardScene implements GameScene {
  private renderManager: RenderManager;
  private audioManager: AudioManager;
  private callbacks: LeaderboardSceneCallbacks;
  private leaderboardManager: LeaderboardManager;
  private leaderboardDisplay: LeaderboardDisplay;

  constructor(renderManager: RenderManager, audioManager: AudioManager, callbacks: LeaderboardSceneCallbacks) {
    this.renderManager = renderManager;
    this.audioManager = audioManager;
    this.callbacks = callbacks;
    this.leaderboardManager = LeaderboardManager.getInstance();
    this.leaderboardDisplay = new LeaderboardDisplay(
      renderManager,
      audioManager,
      () => this.callbacks.switchScene(SceneType.MENU)
    );
  }

  public init(): void {
    console.log('Leaderboard Scene initialized');
    
    // Load leaderboard data
    const gameLeaderboards = this.leaderboardManager.getAllLeaderboards();
    const allTimeLeaderboard = this.leaderboardManager.getAllTimeLeaderboard();
    
    this.leaderboardDisplay.setLeaderboardData(gameLeaderboards, allTimeLeaderboard);
    this.leaderboardDisplay.reset();
  }

  public update(deltaTime: number, input: InputState): void {
    this.leaderboardDisplay.update(deltaTime, input);
  }

  public handleInput(input: InputState): void {
    // Input is handled by the leaderboard display
  }

  public render(ctx: CanvasRenderingContext2D): void {
    this.leaderboardDisplay.render(ctx, 800, 600);
  }

  public cleanup(): void {
    // No cleanup needed
  }
}